import { findUserLogged } from '../../_services/user.service';

export const findLoggedUserEvent = async () => {
    let res = await findUserLogged();
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}